var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup324(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#E69A8D",
    stroke: "#E69A8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 18C29.0837 18.0034 26.2878 19.1635 24.2256 21.2256C22.1635 23.2878 21.0035 26.0837 21 29C20.9965 31.3832 21.775 33.7018 23.216 35.6C23.216 35.6 23.516 35.995 23.565 36.052L32 46L40.439 36.047C40.483 35.994 40.784 35.6 40.784 35.6L40.785 35.597C42.2253 33.6996 43.0034 31.3821 43 29C42.9966 26.0837 41.8365 23.2878 39.7744 21.2256C37.7122 19.1635 34.9163 18.0034 32 18ZM32 33C31.2089 33 30.4355 32.7654 29.7777 32.3259C29.1199 31.8864 28.6072 31.2616 28.3045 30.5307C28.0017 29.7998 27.9225 28.9956 28.0769 28.2196C28.2312 27.4437 28.6122 26.731 29.1716 26.1716C29.731 25.6122 30.4437 25.2312 31.2197 25.0769C31.9956 24.9225 32.7998 25.0017 33.5307 25.3045C34.2616 25.6072 34.8864 26.1199 35.3259 26.7777C35.7654 27.4355 36 28.2089 36 29C35.9987 30.0605 35.5768 31.0771 34.827 31.827C34.0771 32.5768 33.0605 32.9987 32 33Z",
    fill: "#7A51AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup324);
export default __webpack_public_path__ + "static/media/Group324.bf52718352280284f0e761fdd75fe5dc.svg";
export { ForwardRef as ReactComponent };